import { Linking, ScrollView, StyleSheet, Text, TouchableOpacity, View } from 'react-native';
import { LEGAL_CONTACT_EMAIL } from '@/constants/legal';

export default function SupportScreen() {
  return (
    <ScrollView style={s.container} contentContainerStyle={s.content}>
      <View style={s.header}>
        <Text style={s.brand}>MAXIFY</Text>
        <Text style={s.title}>Support</Text>
      </View>

      <View style={s.section}>
        <Text style={s.heading}>Contact Us</Text>
        <Text style={s.body}>
          Have a question, found a bug, or want to request a refund? We typically respond within 1–2 business days.
        </Text>
        <TouchableOpacity
          style={s.emailBtn}
          onPress={() => Linking.openURL(`mailto:${LEGAL_CONTACT_EMAIL}?subject=Maxify Support`)}
          activeOpacity={0.75}
        >
          <Text style={s.emailBtnText}>{LEGAL_CONTACT_EMAIL}</Text>
        </TouchableOpacity>
      </View>

      <View style={s.section}>
        <Text style={s.heading}>Frequently Asked Questions</Text>

        <Text style={s.q}>How do I cancel my subscription?</Text>
        <Text style={s.body}>
          Open your iPhone Settings → tap your name → Subscriptions → Maxify → Cancel Subscription. Cancellation takes effect at the end of your current billing period.
        </Text>

        <Text style={s.q}>Can I get a refund?</Text>
        <Text style={s.body}>
          Refunds are handled by Apple. Visit reportaproblem.apple.com, sign in with your Apple ID, and request a refund there. We do not process refunds directly.
        </Text>

        <Text style={s.q}>My scan isn&apos;t working — what do I do?</Text>
        <Text style={s.body}>
          Make sure you have granted camera permission in your device Settings. Try in a well-lit area with your face clearly in frame. If the issue continues, email us.
        </Text>

        <Text style={s.q}>How is my face photo used?</Text>
        <Text style={s.body}>
          Your photo is sent to our AI provider to generate your scores, then discarded — we do not store it on our servers or your device. See our Privacy Policy for full details.
        </Text>

        <Text style={s.q}>Is Maxify available in my country?</Text>
        <Text style={s.body}>
          Maxify is available worldwide. Face scanning requires location access only to confirm regional legal availability — it is not available in Illinois due to local biometric privacy law.
        </Text>
      </View>

      <View style={s.section}>
        <Text style={s.heading}>Legal</Text>
        <Text style={s.body}>
          Privacy Policy: looksmax.expo.app/privacy{'\n'}
          Terms of Service: looksmax.expo.app/terms
        </Text>
      </View>

      <View style={s.footer} />
    </ScrollView>
  );
}

const s = StyleSheet.create({
  container: { flex: 1, backgroundColor: '#fff' },
  content: { paddingHorizontal: 24, paddingTop: 56, paddingBottom: 80, maxWidth: 720, alignSelf: 'center', width: '100%' },
  header: { marginBottom: 40, borderBottomWidth: 1, borderBottomColor: '#e5e5e5', paddingBottom: 24 },
  brand: { fontSize: 13, fontWeight: '700', letterSpacing: 3, color: '#111', marginBottom: 8 },
  title: { fontSize: 28, fontWeight: '700', color: '#111', lineHeight: 34 },
  section: { marginBottom: 36 },
  heading: { fontSize: 15, fontWeight: '700', color: '#111', marginBottom: 12, lineHeight: 20 },
  body: { fontSize: 14, color: '#444', lineHeight: 22, marginBottom: 12 },
  q: { fontSize: 14, fontWeight: '600', color: '#111', marginTop: 16, marginBottom: 4 },
  emailBtn: { marginTop: 12, alignSelf: 'flex-start', backgroundColor: '#111', paddingVertical: 12, paddingHorizontal: 20, borderRadius: 8 },
  emailBtnText: { fontSize: 14, fontWeight: '600', color: '#fff' },
  footer: { height: 40 },
});
